// components/ui/checkbox.jsx
import * as React from "react";

const Checkbox = React.forwardRef(({ className = "", checked, onCheckedChange, ...props }, ref) => {
  return (
    <div className="relative flex items-center">
      <input
        type="checkbox"
        ref={ref}
        checked={checked}
        onChange={(e) => onCheckedChange?.(e.target.checked)}
        className={`
          h-4 
          w-4 
          rounded 
          border 
          border-gray-300 
          bg-white
          text-primary-600 
          focus:ring-2 
          focus:ring-primary-500 
          focus:ring-offset-2
          disabled:cursor-not-allowed 
          disabled:opacity-50
          ${className}
        `}
        {...props}
      />
    </div>
  );
});

Checkbox.displayName = "Checkbox";

export { Checkbox };